// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateAccountLookup = (state, action) =>
    action.accountLookup;

export default (state = getDefaultState().accountLookup, action) => {

    const actionTypes = {
        [actions.UPDATE_ACCOUNT_LOOKUP]: updateAccountLookup
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/new-transfer/reducers/account-lookup.js